import routerOptions0 from "/var/www/fastwms_ru_usr/data/www/app.fastwms.ru/node_modules/.pnpm/nuxt@3.10.3_@types+node@20.11.24_eslint@8.57.0_sass@1.71.1_stylelint@16.2.1_typescript@5.3.3_vite@5.1.4/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export default {
...configRouterOptions,
...routerOptions0,
}